var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { chartConfig, CommonConstant, NumberUnit } from '../../app.constants';
import { NumberUtils } from '../../utils/number.utils';
import { PdfExportService } from '../../services/export-pdf/pdf-export.service';
import { TranslateService } from '@ngx-translate/core';
function defaultYAxisLabelFormatter() {
    if (this.axis && !isNaN(this.axis.dataMax) && this.axis.dataMax > NumberUnit.BILLION) {
        if (this.isFirst) {
            return '0';
        }
        else if (this.isLast) {
            return '+1b';
        }
        else {
            return '';
        }
    }
    else {
        return NumberUtils.formatNumberToString(this.value);
    }
}
function percentageYAxisLabelFormatter() {
    var value = Math.round(this.value * 100) / 100;
    return value + '%';
}
function thousandYAxisLabelFormatter() {
    return NumberUtils.normalizeNumberToString(this.value);
}
function defaultTooltipFormatter() {
    if (this.series && !isNaN(this.series.dataMax) && this.series.dataMax > NumberUnit.BILLION) {
        return false;
    }
    else {
        return Number(this.y).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
}
function percentageTooltipFormatter() {
    var value = Math.round(this.y * 100) / 100;
    return value + '%';
}
var AchooLineChartComponent = /** @class */ (function () {
    function AchooLineChartComponent(pdfService, translate) {
        this.pdfService = pdfService;
        this.translate = translate;
        this.legendEnabled = true;
        this.xAxisDateTimeLabelFormat = '%d %b';
        this.useDefaultPlaceholder = true;
        this.yAxisValueMode = 'default';
        this.showPlaceholder = false;
        this.placeholderData = [
            [1573257600000, 100000],
            [1573344000000, 0],
            [1573430400000, 80000],
            [1573516800000, 60000],
            [1573603200000, 40000],
            [1573689600000, 0],
            [1573776000000, 20000],
            [1573862400000, 0],
            [1573948800000, 0],
            [1574035200000, 0],
            [1574121600000, 0],
            [1574208000000, 0],
            [1574294400000, 0],
            [1574380800000, 0],
            [1574467200000, 0],
            [1574553600000, 0],
            [1574640000000, 0],
            [1574726400000, 0],
            [1574812800000, 0],
            [1574899200000, 0],
            [1574985600000, 0],
            [1575072000000, 0],
            [1575158400000, 0],
            [1575244800000, 0],
            [1575331200000, 0],
            [1575417600000, 0],
            [1575504000000, 0],
            [1575590400000, 0],
            [1575676800000, 0],
            [1575763200000, 0],
        ];
        this.percentagePlaceholderData = [
            [1573257600000, 10],
            [1573344000000, 0],
            [1573430400000, 8],
            [1573516800000, 6],
            [1573603200000, 4],
            [1573689600000, 0],
            [1573776000000, 2],
            [1573862400000, 0],
            [1573948800000, 0],
            [1574035200000, 0],
            [1574121600000, 0],
            [1574208000000, 0],
            [1574294400000, 0],
            [1574380800000, 0],
            [1574467200000, 0],
            [1574553600000, 0],
            [1574640000000, 0],
            [1574726400000, 0],
            [1574812800000, 0],
            [1574899200000, 0],
            [1574985600000, 0],
            [1575072000000, 0],
            [1575158400000, 0],
            [1575244800000, 0],
            [1575331200000, 0],
            [1575417600000, 0],
            [1575504000000, 0],
            [1575590400000, 0],
            [1575676800000, 0],
            [1575763200000, 0],
        ];
    }
    AchooLineChartComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.chartData.currentValue && this.chart) {
            if (this.hasEmptyData(changes.chartData.currentValue)) {
                this.handleMissingData();
            }
            else {
                this.showPlaceholder = false;
                changes.chartData.currentValue.forEach(function (c, i) {
                    _this.chart.series[i].setData(c.data);
                });
                // enable tooltip if having data
                this.chart.update({
                    tooltip: {
                        enabled: true
                    }
                });
            }
        }
    };
    AchooLineChartComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.fallbackMsg) {
            this.fallbackMsg = this.translate.instant('common.missing_data.line_chart_content');
        }
        // sorting the series data by date
        this.chartData.forEach(function (seri) {
            seri.data.sort(function (a, b) { return a[0] - b[0]; });
        });
        if (this.hasEmptyData(this.chartData)) {
            this.showPlaceholder = true;
            this.chartData = this.chartData.map(function (c) { return Object.assign({}, c, {
                data: _this.yAxisValueMode === 'percentage' ? _this.percentagePlaceholderData : _this.placeholderData
            }); });
        }
        this.options = {
            chart: {
                type: 'line',
                zoomType: 'x',
                spacingBottom: this.spacingBottom || chartConfig.defaultLineChartSpacingBottom,
                spacingRight: this.getConfigValue(this.spacingRight, chartConfig.defaultSpacingRight),
                style: {
                    overflow: 'visible',
                    marginBottom: '8px',
                },
                height: this.height,
                backgroundColor: this.backgroundColor
            },
            title: {
                text: this.chartTitle,
            },
            xAxis: {
                type: 'datetime',
                tickWidth: 0,
                labels: {
                    overflow: 'justify',
                    useHTML: true,
                    format: "{value: " + this.xAxisDateTimeLabelFormat + "}",
                    style: {
                        fontFamily: this.getConfigValue(this.axisFontFamily, chartConfig.font.light),
                        paddingTop: this.xLabelPaddingTop + 'px' || '3px',
                        textTransform: 'uppercase',
                        fontSize: '1rem',
                        color: chartConfig.lightColor,
                        whiteSpace: 'no-wrap',
                        marginTop: '3px',
                    }
                },
            },
            yAxis: {
                title: {
                    text: null
                },
                labels: {
                    formatter: this.chooseYAxisLabelFormatter(this.yAxisValueMode),
                    style: {
                        fontFamily: this.getConfigValue(this.axisFontFamily, chartConfig.font.light),
                        letterSpacing: chartConfig.lineChart.letterSpacing,
                        fontSize: '1rem',
                        color: chartConfig.lightColor
                    }
                },
                tickPixelInterval: 36,
                max: this.yAxisMax
            },
            tooltip: this.getTooltipConfig(),
            plotOptions: {
                line: {
                    lineWidth: chartConfig.lineChart.lineWidth,
                    states: {
                        hover: {
                            lineWidth: chartConfig.lineChart.hoverLineWidth
                        }
                    },
                    marker: {
                        enabled: false
                    },
                },
                series: {
                    animation: !this.pdfService.exportingPdf,
                    enableMouseTracking: !this.showPlaceholder
                },
                area: {
                    fillColor: this.areaFillColor
                }
            },
            legend: {
                enabled: this.legendEnabled,
                align: this.legendAlign || CommonConstant.CHART_OPTIONS.LEGEND_ALIGN.RIGHT,
                verticalAlign: this.legendVerticalAlign || CommonConstant.CHART_OPTIONS.LEGEND_VERTICAL_ALIGN.TOP,
                layout: this.legendLayout || CommonConstant.CHART_OPTIONS.LEGEND_LAYOUT.HORIZONTAL,
                itemStyle: {
                    color: chartConfig.defaultColor,
                    fontWeight: chartConfig.lineChart.legendFontWeight,
                    fontSize: chartConfig.lineChart.legendFontSize,
                    fontFamily: chartConfig.font.light,
                    left: chartConfig.lineChart.legendLeft,
                },
                itemDistance: this.legendItemDistance || chartConfig.defaultLineChartPosition.itemDistance,
                y: this.legendYPosition || chartConfig.defaultLineChartPosition.y,
                x: this.legendXPosition || chartConfig.defaultLineChartPosition.x,
                useHTML: true,
                symbolWidth: 0,
                labelFormatter: function () {
                    return '<div class="d-flex flex-row highcharts-legend-item-content ' + this.name.toLowerCase() + ' align-items-center badge">' +
                        '<div class="flex-g1 highcharts-legend-item-symbol" style="background-color: ' + this.color + ';"> </div>' +
                        '<span class="flex-g1 align-items-center highcharts-legend-item-text">' + this.name + '<span>' +
                        '</div>';
                },
                floating: false,
                margin: this.getConfigValue(this.legendMargin, chartConfig.lineChart.legendMargin)
            },
            credits: {
                enabled: false
            },
            series: this.chartData,
            responsive: {
                rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                itemStyle: {
                                    fontSize: chartConfig.lineChart.legendMobileFontSize,
                                },
                                itemDistance: 1,
                                x: 18,
                                y: -7,
                                useHTML: true,
                            },
                            yAxis: {
                                labels: {
                                    formatter: this.chooseYAxisLabelFormatter(this.yAxisValueMode),
                                    style: {
                                        fontSize: this.smYAxisFontSize || '0.75rem',
                                    }
                                },
                            },
                        }
                    },
                    {
                        condition: {
                            minWidth: 768
                        },
                        chartOptions: {
                            yAxis: {
                                labels: {
                                    formatter: this.yAxisValueMode === 'percentage' ? percentageYAxisLabelFormatter : defaultYAxisLabelFormatter,
                                    style: {
                                        fontSize: '1rem',
                                    }
                                },
                            },
                        }
                    }]
            },
            noData: 'Pending Data...',
            loading: true,
        };
    };
    AchooLineChartComponent.prototype.saveInstance = function (chartInstance) {
        this.chart = chartInstance;
    };
    AchooLineChartComponent.prototype.hasEmptyData = function (chartData) {
        if (!chartData || chartData.length === 0) {
            return true;
        }
        return chartData.filter(function (c) { return c.data && c.data.length > 0; }).length === 0;
    };
    AchooLineChartComponent.prototype.handleMissingData = function () {
        var _this = this;
        if (this.chart) {
            this.chart.series.forEach(function (s) { return s.setData(_this.placeholderData); });
            this.chart.update({
                tooltip: {
                    enabled: false
                }
            });
        }
        this.showPlaceholder = true;
    };
    AchooLineChartComponent.prototype.ngAfterViewInit = function () {
        this.pdfService.incrementNumberReportReady(AchooLineChartComponent.COMPONENT_NAME);
    };
    AchooLineChartComponent.prototype.getConfigValue = function (configValue, defaultValue) {
        if (configValue === null || configValue === undefined) {
            return defaultValue;
        }
        return configValue;
    };
    AchooLineChartComponent.prototype.chooseYAxisLabelFormatter = function (value) {
        switch (value) {
            case 'thousand':
                return thousandYAxisLabelFormatter;
            case 'percentage':
                return percentageYAxisLabelFormatter;
            default:
                return defaultYAxisLabelFormatter;
        }
    };
    AchooLineChartComponent.prototype.getTooltipConfig = function () {
        var defaultConfig = {
            backgroundColor: chartConfig.tooltipBackgroundColor,
            useHTML: true,
            followPointer: false,
            formatter: this.yAxisValueMode === 'percentage' ? percentageTooltipFormatter : defaultTooltipFormatter,
            enabled: !this.showPlaceholder,
            headerFormat: '',
            borderRadius: chartConfig.lineChart.tooltipBorderRadius,
            borderWidth: chartConfig.lineChart.tooltipBorderWidth,
            shadow: false,
            shape: 'callout',
            style: {
                'color': chartConfig.lineChart.tooltipColor,
                fontFamily: chartConfig.font.light,
                'padding': chartConfig.lineChart.tooltipPadding
            }
        };
        return this.overridenTooltipConfig
            ? __assign({}, defaultConfig, this.overridenTooltipConfig) : defaultConfig;
    };
    AchooLineChartComponent.COMPONENT_NAME = 'AchooLineChartComponent';
    return AchooLineChartComponent;
}());
export { AchooLineChartComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-line-chart/achoo-line-chart.component.ts.pre-build-optimizer.js